<script setup>
import { login } from "@/services/auth";

// No authentication check - just show the login button
// EasyAuth will handle authentication at the API level
</script>

<template>
  <div class="h-screen flex items-center justify-center">
    <button @click="login"
            class="px-6 py-3 bg-blue-600 text-white rounded-lg shadow">
      Sign in with Microsoft
    </button>
  </div>
</template>
